define(
    'viewmodels/secured/lists/create',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            i19n: i19n,
            id: '',
            notify: {},
            reload: {},
            comboClick: {},            
            name: ko.observable(''),
            description: ko.observable('')
        });

        vm.activate = function () {
            vm.name('');
            vm.description('');
        };
        vm.attached = function () {
        };
        vm.saveClick = function() {
            var validator = $('#list-form-create').kendoValidator().data('kendoValidator');

            if (validator.validate()) {
                
                dataProvider.lists
                .addList(vm.name(), '')
                .done(function (result) {
                    sessionStorage.setItem("view-list-id", result);
                    vm.notify('success', i19n.to.listcreated);
                    //vm.reload(vm.name());

                    location.reload();
                })
                .fail(function (e) {
                    e.stopPropagation = true;
                    vm.notify(e.error);                        
                });
            }
        };
        vm.cancelClick = function () {
            vm.comboClick();
        };

        return vm;
    }
);
